import { Component, ElementRef, OnInit, Renderer2, ViewChild, HostListener  } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { GtmService, NotifierService, UserService } from '../../_services';
// import { SocialAuthService } from "@abacritt/angularx-social-login";
import { SocialUser } from "@abacritt/angularx-social-login";
import { NavigationStart, Router, NavigationEnd } from '@angular/router';
import { Observable, Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { debounce } from 'lodash';
import { ScrollService } from '../scroller/scroll.service';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Location } from '@angular/common';
import { HttpEvent } from '@angular/common/http';
import { filter } from 'rxjs';
import { ImageCacheService } from 'src/app/_services/ImageCacheService.service';
declare var $: any;

interface userFromBackend {
  userId: string;
  firstName: string;
  lastName: string;
  token: string;
  mobile: number;
  email: string;
  profileImg: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  animations: [
    trigger('headerAnimation', [
      state(
        'visible',
        style({
          opacity: 1,
          transform: 'translateY(0%)',
        })
      ),
      state(
        'hidden',
        style({
          opacity: 0,
          transform: 'translateY(-100%)',
          display: 'none',
        })
      ),
      transition('visible <=> hidden', [animate('300ms ease-in-out')]),
    ]),

    // 🎯 Add this for dropdown animation
    trigger('dropdownAnimation', [
      transition(':enter', [
        style({ height: '0', opacity: 0 }),
        animate('300ms ease-out', style({ height: '*', opacity: 1 })),
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ height: '0', opacity: 0 })),
      ]),
    ]),
  ],
})
export class HeaderComponent implements OnInit {
  private alertCalled = false;
  isHomePage: boolean = false;
  currentRoute: string = '';
  registerForm!: FormGroup;
  loginForm!: FormGroup;
  otpForm!: FormGroup;
  registerSubmitted: boolean = false;
  loginSubmitted: boolean = false;
  enquirySubmitted: boolean = false;
  otpFormSubmitted: boolean = false;
  isAuth: boolean = true;
  loggedInUserData: any;
  sendEnquiryForm!: FormGroup;
  minPrice: any;
  maxPrice: any;
  openDropdown: string | null = null;
  showDropdown: boolean = false;
  isVisible: boolean = true;
  isHomePageNotScrolled: boolean = false;
  private timeoutId: any;
  lastScrollTop: number = 0;
  alertRibbonData: any[] = [];
  topTenProjectsList: any[] = [];
  numberOfItemsFromEndBeforeFetchingMore: number = 2;
  @ViewChild('mobile', { static: false }) mobile!: ElementRef;
  @ViewChild('email', { static: false }) email!: ElementRef;
  @ViewChild('emailMobile', { static: false }) emailMobile!: ElementRef;
  // selectedLocation: any;
  currentUrl!: string;
  token!: string;
  ismobile: boolean = false;
  // URL: any = "https://stgonehome.blob.core.windows.net/files/document-1709728305828-604354-E-Auction%20User%20Guide-Live%20Auction%2C%20Jan%205%2C%202024.pdf"
  URL: any =
    'https://stgonehome.blob.core.windows.net/files/document-1756706935975-c4a989e8c7cd484c-UserGuide.pdf';

  constructor(
    private imageCache: ImageCacheService,
    private _FB: FormBuilder,
    private _US: UserService,
    private _notifier: NotifierService,
    private router: Router,
    private renderer: Renderer2,
    private gtmService: GtmService,
    private scrollService: ScrollService,
    private location: Location
  ) {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      this.ismobile = true;
    } else {
      this.ismobile = false;
    }
  }
  manualProjectsList = [
    {
      prospectNumber: 'EE1',
      projectName: 'E11 Evolve',
      city: 'Hyderabad',
      locality: 'E11 Evolve, Medchal Malkajgiri',
    },
    {
      prospectNumber: 'NS1',
      projectName: 'Northstar Sanctuary',
      city: 'Hyderabad',
      locality:
        'Northstar Sanctuary, Mohabat Nagar Village, Maheshwaram Mandal',
    },
    {
      prospectNumber: 'VAWL1',
      projectName: 'Vasavi Archana White Lotus',
      city: 'Mahabubnagar',
      locality: 'Kethireddypally, Grampanchayat, Balanagat Manda',
    },
    {
      prospectNumber: 'DB1',
      projectName: 'Doon Boulevard',
      city: 'Dehradun',
      locality: 'Village-Bhandar, Pargana Doon',
    },
    {
      prospectNumber: 'RG1',
      projectName: 'Rajvik Greens',
      city: 'Gurgaon',
      locality: 'Sector 79 B , Gurgaon',
    },
    {
      prospectNumber: 'PGP1',
      projectName: 'Panvelkar Greens Phase I',
      city: 'Ambernath',
      locality: 'Panvelkar Greens Phase I, Ambernath, Joveli',
    },
    {
      prospectNumber: 'RP1',
      projectName: 'Riverwood Park',
      city: 'Thane',
      locality: 'Kalyan Shilphata Road Dombiwali, Sangarli Village',
    },
    {
      prospectNumber: 'RA1',
      projectName: 'Rof Atulyas',
      city: 'Gurgaon',
      locality: 'Sector 93, Gurgaon',
    },
  ];
  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      // Check if the event is of type NavigationEnd
      if (event instanceof NavigationEnd) {
        this.isVisible = true; // Reset visibility when the route changes
        this.updateScrollState(window.scrollY);
      }
    });
    this.scrollService.scrollDirection$.subscribe((direction) => {
      // Get the current route
      this.currentRoute = this.router.url;

      // Get the current scroll position
      const currentScrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      // Check if the current route matches and the scroll position exceeds 57px
      if (
        (this.currentRoute.startsWith('/property/details/') ||
          this.currentRoute.startsWith('/property/e-auction/') ||
          this.currentRoute.startsWith('/property/projects/')) &&
        currentScrollTop > 60
      ) {
        if (direction === 'down' && currentScrollTop > this.lastScrollTop) {
          // User is scrolling down and past the threshold
          this.isVisible = false;
        } else if (currentScrollTop == 0) {
          // User is scrolling up
          this.isVisible = true;
        }
      } else {
        // Default to visible for non-matching routes or below the scroll threshold
        this.isVisible = true;
      }
      // Update the last scroll position
      this.lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // Avoid negative values
    });

    this.router.events.subscribe((e) => {
      if (e instanceof NavigationStart) {
        this.currentUrl = e.url;
      }
    });
    this.initializeHeader();
    this.registerForm = this._FB.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      countryCode: ['91'],
      mobile: [
        '',
        [
          Validators.required,
          Validators.pattern('^(\\+?d{1,4}[s-])?(?!0+s+,?$)\\d{10}s*,?$'),
        ],
      ],
      isChecked: [false],
    });
    this.loginForm = this._FB.group({
      registrationType: ['', Validators.required],
    });
    this.otpForm = this._FB.group(
      {
        registrationType: ['email', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        otp1: ['', Validators.required],
        otp2: ['', Validators.required],
        otp3: ['', Validators.required],
        otp4: ['', Validators.required],
        otp5: ['', Validators.required],
        otp6: ['', Validators.required],
        password: ['', Validators.required],
        confirmPassword: ['', Validators.required],
      },
      {
        validator: this.ConfirmedValidator('password', 'confirmPassword'),
      }
    );
    this.sendEnquiryForm = this._FB.group({
      name: ['', Validators.required],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          ),
        ],
      ],
      mobile: [
        '',
        [
          Validators.required,
          Validators.pattern('^(\\+?d{1,4}[s-])?(?!0+s+,?$)\\d{10}s*,?$'),
        ],
      ],
      message: ['', Validators.required],
    });

    this._US.getAuth().subscribe((data: any) => {
      this.isAuth = data;
    });
    this._US.currentSasToken.subscribe((tokens) => (this.token = tokens));
    this._US.getUser().subscribe((data: any) => {
      this.loggedInUserData = data;
    });
    this.searchInput$
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((term) => {
        this.searchKey = term === null || term === '' ? '' : term;
        this.page = 1;
        this.cityList = [];
        this.getCityList();
      });


if (this.isAuth && this.currentRoute === '/' && !this.alertCalled) {
  this.alertCalled = true;
  this.isHomePage=true;
  this.fetchAlertRibbonData();
}else{
  this.alertRibbonData = [];
   this.isHomePage=false;
}

 this.router.events
   .pipe(
     filter((event): event is NavigationEnd => event instanceof NavigationEnd)
   )
   .subscribe((event) => {
     this.isHomePage = event.urlAfterRedirects === '/';
   });

    this.topTenProjects();
  }

  fetchAlertRibbonData() {
    this._US.alertRibbon().subscribe((data: any) => {
      console.log('alertRibbonData111 api response = ', data);
      if (data.meta.status) {
        this.alertRibbonData = data?.data || [];
      }
    });
  }

  topTenProjects() {
    this._US.getTopTenProjects().subscribe((data: any) => {
      console.log('getTopTenProjects api response = ', data);
      if (data.meta.status) {
        this.topTenProjectsList = data?.data?.projects || [];
        console.log('this.topTenProjectsList = ', this.topTenProjectsList);
      }
    });
  }

  redirectTopProject(url: any): Observable<HttpEvent<any>> {
    // const fullUrl = window.location.origin + '/page-not-found';
    console.log(url);

    window.location.href = url;

    // Always return an Observable, even if fullUrl is not present
    return new Observable<HttpEvent<any>>();
  }

  ConfirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (
        matchingControl.errors &&
        !matchingControl.errors['confirmedValidator']
      ) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }
  updateScrollState(currentScrollTop: number): void {
    if (this.router.url === '/' && currentScrollTop < 120) {
      this.isHomePageNotScrolled = true;
    } else {
      this.isHomePageNotScrolled = false;
    }
  }
  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const currentScrollTop =
      window.scrollY || document.documentElement.scrollTop;
    this.updateScrollState(currentScrollTop);
  }
  initializeHeader() {
    $(window).on('scroll', function () {
      if ($(window).scrollTop() >= 10) {
        $('.fixedHeader').addClass('sticky');
      } else {
        $('.fixedHeader').removeClass('sticky');
      }
    });

    // $('.right_menu li.dropdown >a').on('click', function (e: any) {
    //   var $el = $(e.currentTarget),
    //     textNode = e.currentTarget.lastChild;
    //   $el.find('span').toggleClass('fa-angle-right fa-angle-down');
    //   textNode.nodeValue = ' Gimme ' + ($el.hasClass('showFire') ? 'Fire' : 'Water')
    //   $el.toggleClass('showFire');
    // });
  }

  get registerFormControls() {
    return this.registerForm.controls;
  }
  get loginFormControls() {
    return this.loginForm.controls;
  }
  get enquiryFormControls() {
    return this.sendEnquiryForm.controls;
  }
  get otpFormControls() {
    return this.otpForm.controls;
  }

  showRegisterOffCanvas() {
    $('#offcanvasTopRegister').offcanvas('show');
    $('#offcanvasTopRegister').on('hidden.bs.offcanvas', (e: any) => {
      // this.registerForm.reset();
    });
  }

  hideRegisterOffCanvas() {
    $('#offcanvasTopRegister').offcanvas('hide');
  }
  showLoginOffCanvas() {
    $('#offcanvasToplogin').offcanvas('show');
    $('#offcanvasToplogin').on('hidden.bs.offcanvas', (e: any) => {
      this.loginForm.reset();
    });
  }

  hideLoginOffCanvas() {
    $('#offcanvasToplogin').offcanvas('hide');
  }

  register() {
    if (
      this.userId &&
      this.otpForm.get('otp1')?.valid &&
      this.otpForm.get('otp2')?.valid &&
      this.otpForm.get('otp3')?.valid &&
      this.otpForm.get('otp4')?.valid &&
      this.otpForm.get('otp5')?.valid &&
      this.otpForm.get('otp6')?.valid
    ) {
      let otp: string = '';
      otp += this.otpForm.value['otp1'];
      otp += this.otpForm.value['otp2'];
      otp += this.otpForm.value['otp3'];
      otp += this.otpForm.value['otp4'];
      otp += this.otpForm.value['otp5'];
      otp += this.otpForm.value['otp6'];
      let obj = {
        userId: this.userId,
        otp,
      };

      let encrypted = this._US.getEncryptedData(obj);
      this._US.registerNewUser({ data: encrypted }).subscribe((data: any) => {
        if (data.meta.status) {
          let newData = this._US.getDecryptData(data.data);
          const loginEventData = {
            event: 'otp_validation',
            category: 'signup',
            userID: newData._id,
            user_status: 'loggedin', // Nonloggedin.
          };
          this.gtmService.pushDataToDataLayer(loginEventData);
          this.hideOtpModal();
          // this.router.navigate(['/']);
          const user: userFromBackend = {
            token: newData.token,
            userId: newData._id,
            firstName: newData.firstName,
            lastName: newData.lastName,
            email: newData.email,
            mobile: newData.mobile,
            profileImg: newData.profileImg,
          };
          this.afterLogin(user);
          this._notifier.showSuccess(data.meta.msg, 'Success');
        } else {
          this._notifier.showError(data.meta.msg, 'Error');
        }
      });
    } else {
      this.registerSubmitted = true;
    }
  }

  showOtpModal(isRegister: boolean) {
    $('#offcanvasForgotOtp').offcanvas('show');
    $('#offcanvasForgotOtp').on('hidden.bs.offcanvas', (e: any) => {
      isRegister ? this.registerForm.reset({ countryCode: '91' }) : null;
      // this.otpForm.reset({ registrationType: 'email' });
      this.otpForm.get('otp1')?.reset('');
      this.otpForm.get('otp2')?.reset('');
      this.otpForm.get('otp3')?.reset('');
      this.otpForm.get('otp4')?.reset('');
      this.otpForm.get('otp5')?.reset('');
      this.otpForm.get('otp6')?.reset('');
      this.userId = '';
    });
  }

  hideOtpModal() {
    $('#offcanvasForgotOtp').offcanvas('hide');
  }

  userId: string = '';
  registerSendOtp(isResend?: boolean) {
    if (this.registerForm.valid) {
      let obj = this._US.getEncryptedData(this.registerForm.value);
      this._US.registerSendOtp({ data: obj }).subscribe((data: any) => {
        if (data.meta.status) {
          let newData = this._US.getDecryptData(data.data);
          this.userId = newData._id;
          const loginEventData = isResend
            ? {
                event: 'otp_resend',
                category: 'signup',
                userID: this.userId,
                user_status: this.isAuth ? 'loggedin' : 'Nonloggedin', // Nonloggedin.
              }
            : {
                event: 'signup',
                userID: this.userId,
                user_status: this.isAuth ? 'loggedin' : 'Nonloggedin', // Nonloggedin.
              };
          this.gtmService.pushDataToDataLayer(loginEventData);
          this.showOtpModal(true);
          this.hideRegisterOffCanvas();
          this._notifier.showSuccess(data.meta.msg, 'Success');
        } else {
          const loginEventData = {
            event: 'signup',
            userID: '',
            user_status: this.isAuth ? 'loggedin' : 'Nonloggedin', // Nonloggedin.
          };
          this.gtmService.pushDataToDataLayer(loginEventData);
          this._notifier.showError(data.meta.msg, 'Error');
        }
      });
    } else {
      this.registerSubmitted = true;
    }
  }

  isUserExist: boolean = true;
  isSendOtpDisabled: boolean = false;
  errorMsg: string = '';
  nextToPasswordOtp() {
    this.loginSubmitted = false;
    if (this.loginForm.value.registrationType === 'mobile') {
      this.isSendOtpDisabled = true;
      if (this.loginForm.get('mobile')?.valid) {
        this.onEnterPressDebounced();
      } else {
        this.loginSubmitted = true;
      }
    } else if (this.loginForm.value.registrationType === 'email') {
      if (this.loginForm.get('email')?.valid) {
        $('#offcanvasTopSignin').offcanvas('hide');
        $('#offcanvasTopPassword').offcanvas('show');
      } else {
        this.loginSubmitted = true;
      }
    }
  }

  onEnterPressDebounced = debounce(() => {
    let obj = {
      registrationType: this.loginForm.value.registrationType,
      mobile: this.loginForm.get('mobile')?.value,
      countryCode: this.loginForm.get('countryCode')?.value,
    };
    let objNew = this._US.getEncryptedData(obj);

    this._US.sendOtp({ data: objNew }).subscribe(
      (data: any) => {
        this.isSendOtpDisabled = false;
        if (data.meta.status) {
          $('#offcanvasTopSignin').offcanvas('hide');
          $('#offcanvasTopOTP').offcanvas('show');
          this._notifier.showSuccess(data.meta.msg, 'Success');
        } else {
          this.isUserExist = data.meta?.isUserExist;
          !this.isUserExist
            ? (this.errorMsg = data.meta.msg)
            : this._notifier.showError(data.meta.msg, 'Error');
        }
      },
      (err) => {
        this.isSendOtpDisabled = false;
      }
    );
  }, 500);

  isPasswordCorrect: boolean = true;
  loginByEmail() {
    if (this.loginForm.valid) {
      let obj = this._US.getEncryptedData(this.loginForm.value);
      this._US.loginByEmail({ data: obj }).subscribe((data: any) => {
        if (data.meta.status) {
          let newData = this._US.getDecryptData(data.data);
          const loginEventData = {
            event: 'login',
            method: 'email',
            userID: newData._id,
            user_status: 'loggedin',
          };
          this.gtmService.pushDataToDataLayer(loginEventData);
          this.loginForm.reset();
          $('#offcanvasTopPassword').offcanvas('hide');
          const user: userFromBackend = {
            token: newData.token,
            userId: newData._id,
            firstName: newData.firstName,
            lastName: newData.lastName,
            email: newData.email,
            mobile: newData.mobile,
            profileImg: newData.profileImg,
          };
          this.afterLogin(user);
          this._notifier.showSuccess(data.meta.msg, 'Success');
          window.location.reload();
        } else {
          if (data.hasOwnProperty('isPasswordCorrect')) {
            this.isPasswordCorrect = data?.isPasswordCorrect;
          } else {
            const loginEventData = {
              event: 'login',
              method: 'email',
              userID: '',
              user_status: this.isAuth ? 'loggedin' : 'Nonloggedin',
            };
            this.gtmService.pushDataToDataLayer(loginEventData);
            this._notifier.showError(data.meta.msg, 'Error');
          }
        }
      });
    } else {
      this.loginSubmitted = true;
    }
  }

  verifyOtp() {
    if (this.loginForm.valid) {
      let obj = this._US.getEncryptedData(this.loginForm.value);
      this._US.verifyOtp({ data: obj }).subscribe((data: any) => {
        if (data.meta.status) {
          let newData = this._US.getDecryptData(data.data);
          const loginEventData = {
            event: 'login',
            method: 'Phone',
            userID: newData._id,
            user_status: 'loggedin',
          };
          this.gtmService.pushDataToDataLayer(loginEventData);
          this.loginForm.reset();
          $('#offcanvasTopOTP').offcanvas('hide');
          const user: userFromBackend = {
            token: newData.token,
            userId: newData._id,
            firstName: newData.firstName,
            lastName: newData.lastName,
            email: newData.email,
            mobile: newData.mobile,
            profileImg: newData.profileImg,
          };
          this.afterLogin(user);
          this._notifier.showSuccess(data.meta.msg, 'Success');
          window.location.reload();
        } else {
          const loginEventData = {
            event: 'login',
            method: 'Phone',
            userID: '',
            user_status: this.isAuth ? 'loggedin' : 'Nonloggedin',
          };
          this.gtmService.pushDataToDataLayer(loginEventData);
          this._notifier.showError(data.meta.msg, 'Error');
        }
      });
    } else {
      this.loginSubmitted = true;
    }
  }

  afterLogin(user: any) {
    let encryptedData = this._US.getEncryptedData(user);
    // localStorage.setItem('oneHomeCurrentUser', encryptedData);
    localStorage.setItem('oneHomeCurrentUser', JSON.stringify(encryptedData));
    this._US.updateUserAuth(true, user);
  }

  changeRegisterType(eve: any) {
    this.loginSubmitted = false;
    if (eve.target.value === 'mobile') {
      this.loginForm.removeControl('email');
      this.loginForm.removeControl('password');
      this.loginForm.addControl(
        'otp',
        new FormControl('', Validators.required)
      );
      this.loginForm.addControl(
        'mobile',
        new FormControl('', Validators.required)
      );
      this.loginForm.addControl(
        'countryCode',
        new FormControl('91', Validators.required)
      );
    } else if (eve.target.value === 'email') {
      this.loginForm.addControl(
        'email',
        new FormControl('', Validators.required)
      );
      this.loginForm.addControl(
        'password',
        new FormControl('', Validators.required)
      );
      this.loginForm.removeControl('otp');
      this.loginForm.removeControl('mobile');
      this.loginForm.removeControl('countryCode');
    }
  }

  showEnquiryModal() {
    if (!this.loggedInUserData) {
      $('#offcanvasTopSignin').offcanvas('show');
      $('#offcanvasTopSignin').on('hidden.bs.offcanvas', (e: any) => {
        this.loginForm.reset();
      });
      return;
    }
    const loginEventData = {
      event: 'cta_click',
      click_category: 'Contact Us', // Blogs
      click_text: 'Send Enquiry',
      userID: this.isAuth ? this.loggedInUserData.userId : '',
      user_status: this.isAuth ? 'loggedin' : 'Nonloggedin', // Nonloggedin.
    };
    this.gtmService.pushDataToDataLayer(loginEventData);
    $('#SendEnquiryModal').modal('show');
    $('#SendEnquiryModal').on('hidden.bs.modal', (e: any) => {
      this.sendEnquiryForm.reset();
    });
    setTimeout(() => {
      $('.modal-backdrop').removeClass('show').addClass('hide');
      $('.modal-backdrop').css('z-index', '-10');
      this.sendEnquiryForm.patchValue({
        name:
          this.loggedInUserData.firstName +
          ' ' +
          this.loggedInUserData.lastName,
        email: this.loggedInUserData.email,
        mobile: this.loggedInUserData.mobile,
      });
    }, 1000);
  }

  hideEnquiryModal() {
    $('#SendEnquiryModal').modal('hide');
  }

  isDisabledSendEnquiry: boolean = false;
  sendEnquiry() {
    if (this.sendEnquiryForm.valid) {
      this.isDisabledSendEnquiry = true;
      this.sendEnquiryForm.value.mobile =
        this.sendEnquiryForm.value.mobile.toString();
      let obj1 = {
        source: 'CONTACTUS',
        ...this.sendEnquiryForm.value,
      };
      let obj = this._US.getEncryptedData(obj1);
      this._US.sendEnquiry({ data: obj }).subscribe(
        (data: any) => {
          this.isDisabledSendEnquiry = false;
          if (data.meta.status) {
            const loginEventData = {
              event: 'contact_us',
              click_category: 'Contact Us', // Blogs
              click_text: 'Submit',
              click_location: 'header',
              userID: this.isAuth ? this.loggedInUserData.userId : '',
              user_status: this.isAuth ? 'loggedin' : 'Nonloggedin', // Nonloggedin.
            };
            this.gtmService.pushDataToDataLayer(loginEventData);
            this.hideEnquiryModal();
            this.sendEnquiryForm.reset();
            this._notifier.showSuccess(data.meta.msg, 'Success');
          } else {
            this._notifier.showError(data.meta.msg, 'Error');
          }
        },
        (error) => {
          this.isDisabledSendEnquiry = false;
          this.hideEnquiryModal();
          this._notifier.showError('Something went wrong', 'Error');
        }
      );
    } else {
      this.enquirySubmitted = true;
    }
  }
  redirectRoutingList(params: any, state: any, from: any) {
    let formattedSentence = params
      ? params.replace(/\s+/g, '-').toLowerCase()
      : '';
    this.router.navigate(
      [
        `${
          from == 'normalSearch'
            ? state.propertyFor == 2
              ? '/buy-auction-properties-in-' + formattedSentence
              : '/buy-properties-in-' + formattedSentence
            : from == 'budget'
            ? state.propertyFor == 2
              ? '/buy-auction-properties-in-price-range-' + formattedSentence
              : `/buy-properties-in-price-range-` + formattedSentence
            : from == 'discount'
            ? `/properties-in-discount-percent-range-` + formattedSentence
            : '/property/list'
        }`,
      ],
      {
        state: state,
      }
    );
    sessionStorage.setItem('propertyState', JSON.stringify(state));
  }
  headerProjectRouting(searchKey: any, propertyForKey: any) {
    let urlSegments: string[] = [];
    const manualProjectData = this.getProjectByName(searchKey);

    if (searchKey) {
      urlSegments.push(searchKey.toLowerCase());
    }

    // Add locality if defined
    if (manualProjectData?.locality) {
      urlSegments.push(manualProjectData.locality.toLowerCase());
    }

    // Add cityName if defined and not equal to locality
    if (
      manualProjectData?.city &&
      manualProjectData?.city.toLowerCase() !==
        manualProjectData?.locality?.toLowerCase()
    ) {
      urlSegments.push(manualProjectData.city.toLowerCase());
    }

    const dynamicUrl = urlSegments
      .join('-')
      .replace(/[^a-zA-Z0-9-]+/g, '-')
      .toLowerCase();

    // Create final URL
    let url = this.router.serializeUrl(
      //  this.router.createUrlTree([`/property/${property.propertyFor == 2?'e-auction':'projects'}`, dynamicUrl.replace(/[^a-zA-Z0-9-]+/g, '-').toLowerCase(),property._id]
      this.router.createUrlTree([
        `/property/projects`,
        dynamicUrl.replace(/[^a-zA-Z0-9-]+/g, '-').toLowerCase(),
        manualProjectData?.prospectNumber || '',
      ])
    );

    // Prepare and open the external URL
    url = this.location.prepareExternalUrl(url);
    sessionStorage.setItem(
      'property_id',
      manualProjectData?.prospectNumber || ''
    );
    window.open(url, '_blank');
  }

  headerRouting(searchKey: any, propertyForKey: any) {
    this.searchKey = searchKey;
    this.showDropdown = false;
    $('.modal-backdrop').removeClass('show').addClass('hide');
    $('#offcanvasRightMenu').offcanvas('hide');

    // this.router.navigate(['/property/list'], {
    //   queryParams: {
    //     searchKey: this.searchKey,minPrice: this.minPrice,maxPrice: this.maxPrice,
    //     propertyFor:propertyForKey
    //   }
    // });
    let state = {
      searchKey: this.searchKey,
      minPrice: this.minPrice,
      maxPrice: 500000000,
      propertyFor: propertyForKey,
      propertyForKey: 1,
    };
    let from = 'normalSearch';
    this.redirectRoutingList(this.searchKey, state, from);
  }
  headerPriceRouting(minPrice: any, maxPrice: any, propertyForKey: any) {
    this.showDropdown = false;
    $('.modal-backdrop').removeClass('show').addClass('hide');
    $('#offcanvasRightMenu').offcanvas('hide');

    //  this.router.navigate(['/property/list'], {
    //   queryParams: {
    //    minPrice: minPrice,maxPrice: maxPrice,
    //     propertyFor:propertyForKey
    //   }
    // });
    let state = {
      minPrice: minPrice,
      maxPrice: maxPrice,
      propertyFor: propertyForKey,
    };
    let from = 'budget';
    this.redirectRoutingList(`${minPrice + '-' + maxPrice}`, state, from);
  }
  headerDiscountRouting(minPrice: any, maxPrice: any, propertyForKey: any) {
    this.showDropdown = false;
    $('.modal-backdrop').removeClass('show').addClass('hide');
    $('#offcanvasRightMenu').offcanvas('hide');
    //   this.router.navigate(['/property/list'], {
    //    queryParams: {
    //     discountFilterRangeStartValue: minPrice,discountFilterRangeEndValue: maxPrice,
    //      propertyFor:propertyForKey
    //    }
    //  });
    let state = {
      discountFilterRangeStartValue: minPrice,
      discountFilterRangeEndValue: maxPrice,
      propertyFor: propertyForKey,
    };
    let from = 'discount';
    this.redirectRoutingList(`${minPrice + '-' + maxPrice}`, state, from);
  }
  headerBrowserRouting() {
    this.showDropdown = false;
    $('.modal-backdrop').removeClass('show').addClass('hide');
    this.router.navigate(['/property/list'], {
      state: {},
    });
    sessionStorage.setItem('propertyState', JSON.stringify({}));
  }
  headerArticleHide(subName: string) {
    this.showDropdown = false;
    $('.modal-backdrop').removeClass('show').addClass('hide');
    $('#offcanvasRightMenu').offcanvas('hide');
    this.ctaClickEventHam('Knowledge Hub', subName);
  }
  hideMenu() {
    $('#offcanvasRightMenu').offcanvas('hide');
  }
  socialLogin(user: SocialUser) {
    // authToken Facebook
    let obj = {
      type:
        user.provider === 'FACEBOOK' ? 2 : user.provider === 'GOOGLE' ? 1 : 1,
      ...(user.provider === 'GOOGLE' && { token: user.idToken }),
      ...(user.provider === 'FACEBOOK' && {
        name: user.name,
        picture: user.photoUrl,
        email: user.email,
      }),
    };
    let objNew = this._US.getEncryptedData(obj);
    this._US.socialLogin({ data: objNew }).subscribe((data: any) => {
      if (data.meta.status) {
        let newData = this._US.getDecryptData(data.data);
        $('#offcanvasToplogin').offcanvas('hide');
        const user: userFromBackend = {
          token: newData.token,
          userId: newData._id,
          firstName: newData.firstName,
          lastName: newData.lastName,
          email: newData.email,
          mobile: newData.mobile,
          profileImg: newData.profileImg,
        };
        this.afterLogin(user);
        this._notifier.showSuccess(data.meta.msg, 'Success');
      } else {
        this._notifier.showError(data.meta.msg, 'Error');
      }
    });
  }

  logout() {
    this.showDropdown = false;
    localStorage.removeItem('oneHomeCurrentUser');
    this._US.logout().subscribe((data: any) => {
      if (data.meta.status) {
        this._notifier.showSuccess(data.meta.msg, 'Success');
        this._US.updateUserAuth(false, null);
        window.location.reload();
        // this.router.navigate(['/']);
      } else {
        this._notifier.showSuccess(data.meta.msg, 'Error');
      }
    });
  }

  routeToHome() {
    this.router.navigate(['/']);
    window.scrollTo(0, 0);
  }

  isMobile(event: any, formGroup: FormGroup) {
    if (event.target.value) {
      if (!isNaN(event.target.value)) {
        formGroup.removeControl('email');
        formGroup.removeControl('password');
        formGroup.addControl('otp', new FormControl('', Validators.required));
        formGroup.addControl(
          'mobile',
          new FormControl(event.target.value, [
            Validators.required,
            Validators.pattern('^(\\+?d{1,4}[s-])?(?!0+s+,?$)\\d{10}s*,?$'),
          ])
        );
        formGroup.addControl(
          'countryCode',
          new FormControl('91', Validators.required)
        );
        formGroup.get('registrationType')?.setValue('mobile');
        setTimeout(() => {
          this.mobile.nativeElement.focus();
        });
      } else if (isNaN(event.target.value)) {
        formGroup.addControl(
          'email',
          new FormControl(event.target.value, [
            Validators.required,
            Validators.email,
          ])
        );
        formGroup.addControl(
          'password',
          new FormControl('', Validators.required)
        );
        formGroup.removeControl('otp');
        formGroup.removeControl('mobile');
        formGroup.removeControl('countryCode');
        formGroup.get('registrationType')?.setValue('email');
        setTimeout(() => {
          this.email.nativeElement.focus();
        });
      }
    } else {
      formGroup.removeControl('otp');
      formGroup.removeControl('mobile');
      formGroup.removeControl('countryCode');
      formGroup.removeControl('email');
      formGroup.removeControl('password');
      formGroup.get('registrationType')?.setValue('');
      setTimeout(() => {
        this.emailMobile.nativeElement.focus();
      });
    }
  }

  hideOffcanvasRightMenu(name: string, subName: string) {
    $('#offcanvasRightMenu').offcanvas('hide');
    this.ctaClickEventHam(name, subName);
  }

  showForotpasswordModal() {
    this.loginForm.value.hasOwnProperty('email') &&
      this.otpForm.get('email')?.setValue(this.loginForm.value.email);
    $('#offcanvasTopPassword').offcanvas('hide');
    $('#offcanvasTopNoLogin').offcanvas('show');
  }

  nextStep(event: any, step: number): void {
    const prevElement = document.getElementById('otp' + (step - 1));
    const nextElement = document.getElementById('otp' + (step + 1));
    if (event.code == 'Backspace' && event.target.value === '') {
      // event.target.parentElement.parentElement.children[step - 2 > 0 ? step - 2 : 0].children[0].value = ''
      if (prevElement) {
        prevElement.focus();
        return;
      }
    } else {
      if (nextElement) {
        nextElement.focus();
        return;
      } else {
      }
    }
  }

  paste(event: any) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    setTimeout(() => {
      this.otpForm.reset();
      this.otpForm.setValue({
        otp1: pastedText.charAt(0),
        otp2: pastedText.charAt(1),
        otp3: pastedText.charAt(2),
        otp4: pastedText.charAt(3),
        otp5: pastedText.charAt(4),
        otp6: pastedText.charAt(5),
      });
    }, 100);
  }

  focused(step: number) {
    if (step === 2) {
      if (this.otpForm.controls['otp1'].value === '') {
        this.renderer.selectRootElement('#otp1').focus();
      }
    }
    if (step === 3) {
      if (
        this.otpForm.controls['otp1'].value === '' ||
        this.otpForm.controls['otp2'].value === ''
      ) {
        this.renderer.selectRootElement('#otp2').focus();
      }
    }
    if (step === 4) {
      if (
        this.otpForm.controls['otp1'].value === '' ||
        this.otpForm.controls['otp2'].value === '' ||
        this.otpForm.controls['otp3'].value === ''
      ) {
        this.renderer.selectRootElement('#otp3').focus();
      }
    }
    if (step === 5) {
      if (
        this.otpForm.controls['otp1'].value === '' ||
        this.otpForm.controls['otp2'].value === '' ||
        this.otpForm.controls['otp3'].value === '' ||
        this.otpForm.controls['otp4'].value === ''
      ) {
        this.renderer.selectRootElement('#otp4').focus();
      }
    }
    if (step === 6) {
      if (
        this.otpForm.controls['otp1'].value === '' ||
        this.otpForm.controls['otp2'].value === '' ||
        this.otpForm.controls['otp3'].value === '' ||
        this.otpForm.controls['otp4'].value === '' ||
        this.otpForm.controls['otp5'].value === ''
      ) {
        this.renderer.selectRootElement('#otp5').focus();
      }
    }
  }

  sendOtp(isResend?: boolean) {
    if (this.otpForm.value.registrationType === 'email') {
      if (this.otpForm.get('email')?.valid) {
        let obj = {
          registrationType: this.otpForm.value.registrationType,
          email: this.otpForm.get('email')?.value,
        };
        let objNew = this._US.getEncryptedData(obj);
        const loginEventData = isResend
          ? {
              event: 'otp_resend',
              category: 'Forgot Password',
              userID: '',
              user_status: this.isAuth ? 'loggedin' : 'Nonloggedin', // Nonloggedin.
            }
          : {
              event: 'otp_send',
              category: 'Forgot Password',
              userID: '',
              user_status: this.isAuth ? 'loggedin' : 'Nonloggedin', // Nonloggedin.
            };
        this.gtmService.pushDataToDataLayer(loginEventData);
        this._US.forgotSendOtp({ data: objNew }).subscribe((data: any) => {
          if (data.meta.status) {
            this.otpFormSubmitted = false;
            $('#offcanvasTopNoLogin').offcanvas('hide');
            $('#offcanvasForgotOtp').offcanvas('show');
            this._notifier.showSuccess(data.meta.msg, 'Success');
          } else {
            this.isUserExist = data.meta?.isUserExist;
            !this.isUserExist
              ? (this.errorMsg = data.meta.msg)
              : this._notifier.showError(data.meta.msg, 'Error');
            this._notifier.showError(data.meta.msg, 'Error');
          }
        });
      } else {
        this.otpFormSubmitted = true;
      }
    } else if (this.otpForm.value.registrationType === 'mobile') {
      if (this.otpForm.get('mobile')?.valid) {
        let obj = {
          registrationType: this.otpForm.value.registrationType,
          mobile: this.otpForm.get('mobile')?.value,
          countryCode: this.otpForm.get('countryCode')?.value,
        };
        let objNew = this._US.getEncryptedData(obj);
        const loginEventData = isResend
          ? {
              event: 'otp_resend',
              category: 'Forgot Password',
              userID: '',
              user_status: this.isAuth ? 'loggedin' : 'Nonloggedin', // Nonloggedin.
            }
          : {
              event: 'otp_send',
              category: 'Forgot Password',
              userID: '',
              user_status: this.isAuth ? 'loggedin' : 'Nonloggedin', // Nonloggedin.
            };
        this.gtmService.pushDataToDataLayer(loginEventData);
        this._US.forgotSendOtp({ data: objNew }).subscribe((data: any) => {
          if (data.meta.status) {
            this.otpFormSubmitted = false;
            $('#offcanvasTopNoLogin').offcanvas('hide');
            $('#offcanvasForgotOtp').offcanvas('show');
            this._notifier.showSuccess(data.meta.msg, 'Success');
          } else {
            this.isUserExist = data.meta?.isUserExist
              ? data.meta?.isUserExist
              : this.isUserExist;
            !this.isUserExist
              ? (this.errorMsg = data.meta.msg)
              : this._notifier.showError(data.meta.msg, 'Error');
          }
        });
      } else {
        this.otpFormSubmitted = true;
      }
    }
  }

  verifyForgotOtp() {
    if (
      this.otpForm.get('otp1')?.valid &&
      this.otpForm.get('otp2')?.valid &&
      this.otpForm.get('otp3')?.valid &&
      this.otpForm.get('otp4')?.valid &&
      (this.otpForm.get('mobile')?.valid || this.otpForm.get('email')?.valid)
    ) {
      let otp: string = '';
      otp += this.otpForm.value['otp1'];
      otp += this.otpForm.value['otp2'];
      otp += this.otpForm.value['otp3'];
      otp += this.otpForm.value['otp4'];
      otp += this.otpForm.value['otp5'];
      otp += this.otpForm.value['otp6'];
      let obj = {
        registrationType: this.otpForm.value.registrationType,
        ...(this.otpForm.value.registrationType === 'mobile' && {
          mobile: this.otpForm.get('mobile')?.value,
          countryCode: this.otpForm.get('countryCode')?.value,
        }),
        ...(this.otpForm.value.registrationType === 'email' && {
          email: this.otpForm.get('email')?.value,
        }),
        otp,
      };
      let objNew = this._US.getEncryptedData(obj);
      this._US.verifyForgotOtp({ data: objNew }).subscribe((data: any) => {
        if (data.meta.status) {
          const loginEventData = {
            event: 'otp_validation',
            category: 'ForgotPassword',
            userID: '',
            user_status: this.isAuth ? 'loggedin' : 'Nonloggedin', // Nonloggedin.
          };
          this.gtmService.pushDataToDataLayer(loginEventData);
          this.otpFormSubmitted = false;
          $('#offcanvasForgotOtp').offcanvas('hide');
          $('#offcanvasTopForgotPassword').offcanvas('show');
          this._notifier.showSuccess(data.meta.msg, 'Success');
        } else {
          this.isUserExist = data.meta?.isUserExist
            ? data.meta?.isUserExist
            : this.isUserExist;
          !this.isUserExist
            ? (this.errorMsg = data.meta.msg)
            : this._notifier.showError(data.meta.msg, 'Error');
        }
      });
    } else {
      this.otpFormSubmitted = true;
    }
  }

  submitForgotPassword() {
    if (this.otpForm.valid) {
      let otp: string = '';
      otp += this.otpForm.value['otp1'];
      otp += this.otpForm.value['otp2'];
      otp += this.otpForm.value['otp3'];
      otp += this.otpForm.value['otp4'];
      otp += this.otpForm.value['otp5'];
      otp += this.otpForm.value['otp6'];
      let obj = {
        registrationType: this.otpForm.value.registrationType,
        ...(this.otpForm.value.registrationType === 'mobile' && {
          mobile: this.otpForm.get('mobile')?.value,
          countryCode: this.otpForm.get('countryCode')?.value,
        }),
        ...(this.otpForm.value.registrationType === 'email' && {
          email: this.otpForm.get('email')?.value,
        }),
        otp,
        password: this.otpForm.value.password,
        confirmPassword: this.otpForm.value.confirmPassword,
      };
      let objNew = this._US.getEncryptedData(obj);
      this._US.submitForgotPassword({ data: objNew }).subscribe((data: any) => {
        if (data.meta.status) {
          const loginEventData = {
            event: 'password_change',
            category: 'ForgotPassword',
            userID: '',
            user_status: this.isAuth ? 'loggedin' : 'Nonloggedin', // Nonloggedin.
          };
          this.gtmService.pushDataToDataLayer(loginEventData);
          this.otpFormSubmitted = false;
          $('#offcanvasTopForgotPassword').offcanvas('hide');
          this.otpForm.reset({
            registrationType: 'email',
            email: this.loginForm.value.hasOwnProperty('email')
              ? this.loginForm.value.email
              : '',
          });
          this._notifier.showSuccess(data.meta.msg, 'Success');
        } else {
          const loginEventData = {
            event: 'password_change',
            category: 'ForgotPassword',
            userID: '',
            user_status: this.isAuth ? 'loggedin' : 'Nonloggedin', // Nonloggedin.
          };
          this.gtmService.pushDataToDataLayer(loginEventData);
          this.isUserExist = data.meta?.isUserExist;
          !this.isUserExist
            ? (this.errorMsg = data.meta.msg)
            : this._notifier.showError(data.meta.msg, 'Error');
        }
      });
    } else {
      this.otpFormSubmitted = true;
    }
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedText: any = event.clipboardData?.getData('text');
    const disallowedCharacters = '"<>:;|&/ \\#*';
    const regex = new RegExp(`[${this.escapeRegExp(disallowedCharacters)}]`);
    if (regex.test(pastedText)) {
      alert('Special characters are not allowed');
    } else {
      this.searchKey = pastedText;
    }
  }
  private escapeRegExp(string: string): string {
    return string.replace(/[\[\]\/\\^$.*+?{}()|[\]\/\\]/g, '\\$&');
  }

  preventSpecialChars(event: any) {
    const inputValue: string = event.target.value;
    const sanitizedValue: string = this.sanitizeString(inputValue);
    // Update the input value to the sanitized value
    event.target.value = sanitizedValue;
    this.searchKey = sanitizedValue;
  }

  sanitizeString(input: string): string {
    // Define the disallowed characters
    const disallowedChars = /[<>{}[\]$*|'"\\]/;
    // Remove disallowed characters using regex
    return input.replace(disallowedChars, '');
  }

  cityList: any = [];
  loading: boolean = false;
  page: number = 1;
  contentPerPage: number = 20;
  getCityList() {
    this.loading = true;
    this._US
      .getCityList(this.page, this.contentPerPage, this.searchKey)
      .subscribe((data: any) => {
        if (data.meta.status) {
          this.loading = false;
          this.total = data.total;
          this.cityList = [...this.cityList, ...data.data];
        } else {
          this.loading = false;
        }
      });
  }

  total: number = 0;
  searchKey: string = '';
  searchInput$ = new Subject<string>();
  onScrollToEnd() {
    this.page += 1;
    this.getCityList();
  }

  onScroll({ end }: any) {
    if (this.loading || this.total <= this.cityList.length) {
      return;
    }

    if (
      end + this.numberOfItemsFromEndBeforeFetchingMore >=
      this.cityList.length
    ) {
      this.page += 1;
      this.getCityList();
    }
  }

  // onChange(eve: any) {
  //   if (eve) {
  //     this.selectedLocation = { city: eve.name, lat: eve.latitude, lng: eve.longitude };
  //   }
  // }

  // search() {
  //   if (this.selectedLocation) {
  //     localStorage.setItem("selectedLocation", JSON.stringify(this.selectedLocation));
  //     this._US.updateLocation(this.selectedLocation);
  //     $('#searchmodal').modal('hide');
  //     this.router.navigate(['/property/list']);
  //   }
  // }

  ctaClickEvent(name: string) {
    this.showDropdown = false;
    $('.modal-backdrop').removeClass('show').addClass('hide');
    $('#offcanvasRightMenu').offcanvas('hide');
    const loginEventData = {
      event: 'navigation_interaction',
      click_header: name,
      click_location: 'header',
      userID: this.isAuth ? this.loggedInUserData.userId : '',
      user_status: this.isAuth ? 'loggedin' : 'Nonloggedin', // Nonloggedin.
    };
    this.gtmService.pushDataToDataLayer(loginEventData);
  }

  ctaClickProfile(name: string) {
    const loginEventData = {
      event: 'profile_modification',
      click_header: name,
      click_category: 'My Profile',
      click_text: 'My Profile',
      userID: this.isAuth ? this.loggedInUserData.userId : '',
      user_status: this.isAuth ? 'loggedin' : 'Nonloggedin', // Nonloggedin.
    };
    this.gtmService.pushDataToDataLayer(loginEventData);
  }

  gaPushLayer(type: string) {
    const loginEventData = {
      event: 'cta_click',
      click_category: 'contact us',
      click_text: type, //care@iiflonehome.com
      click_location: 'header',
      userID: this.isAuth ? this.loggedInUserData.userId : '',
      user_status: this.isAuth ? 'loggedin' : 'Nonloggedin', // Nonloggedin.
    };
    this.gtmService.pushDataToDataLayer(loginEventData);
  }

  ctaClickEventHam(name: string, subName: string) {
    const loginEventData = {
      event: 'navigation_interaction',
      click_header: name,
      click_location: 'header_hamburger',
      click_subheader: subName, //Search Properties, etc
      userID: this.isAuth ? this.loggedInUserData.userId : '',
      user_status: this.isAuth ? 'loggedin' : 'Nonloggedin', // Nonloggedin.
    };
    this.gtmService.pushDataToDataLayer(loginEventData);
  }

  closeDropdown(): void {
    this.openDropdown = null;
  }
  toggleDropdown(id: string, event: Event): void {
    event.stopPropagation(); // Prevent event from propagating to parent elements
    this.openDropdown = this.openDropdown === id ? null : id;
  }

  getProjectByName(name: string | '') {
    return this.manualProjectsList.find(
      (p) => p.projectName.toLowerCase() === name.toLowerCase()
    );
  }
  openUserGuide(event: Event): void { event.preventDefault(); 
   const newTab = window.open('', '_blank'); if (!newTab) 
    { console.error('Popup was blocked by the browser'); return; } 
   newTab.document.write('Loading User Guide...');
    this.imageCache.getImage(this.URL).subscribe({ next: (url: string) => { 
      if (url) { newTab.location.href = url; this.headerArticleHide('User Guide'); } 
    else { newTab.close(); } }, error: (error) => { console.error('Unable to get User Guide URL', error); newTab.close(); } }); }

}
